export const ASSET_FORM_TYPE = "assetType";
export const SPACE_FORM_TYPE = "spaceType";